import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { WorkInProgressComponent } from './work-in-progress/work-in-progress.component';
import { DoctorServiceReportComponent } from './doctor-service-report/doctor-service-report.component';
import { ExternalRedirectComponent } from './external-redirect.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'lab-order/create',
  },
  {
    path: 'redirect/:externalUrl',
    component: ExternalRedirectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'wip/:linkTo',
    component: WorkInProgressComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'report/:orderNumber',
    component: DoctorServiceReportComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'lab-order/create',
    loadChildren: () =>
      import('./create/create.module').then(m => m.CreateModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'lab-order/search',
    loadChildren: () =>
      import('./search/search.module').then(m => m.SearchModule),
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: 'lab-order/create', pathMatch: 'full' },
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forRoot(routes)],
})
export class AppRoutingModule {}
